import * as React from 'react';
import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

export const CloseIcon = props => {
    return (
        <Svg
            xmlns="http://www.w3.org/2000/svg"
            width={props.width || 24}
            height={props.height || 24}
            viewBox="0 0 24 24"
            fill="none"
            {...props}
        >
            <G clipPath="url(#clip0_54043_4823)">
                <Path
                    d="M4.929 4.929L19.07 19.07m-14.142 0L19.07 4.93"
                    stroke={props.color || ds.colorValue.icon.primary}
                    strokeWidth={2}
                />
            </G>
            <Defs>
                <ClipPath id="clip0_54043_4823">
                    <Path fill={props.color || ds.colorValue.icon.primary} d="M0 0H24V24H0z" />
                </ClipPath>
            </Defs>
        </Svg>
    );
};
